import get from 'lodash/get';
import { substances, reactions } from '@Constants';
import ResultsInterface from '@Services/ResultsInterface';
import UserDatabases from '@Services/UserDatabases';
import store from '@Store';
import { query as querySelector } from '@Pages/QuickSearch/Components/QuickResults/QuickResultsSelectors';
import { trackPreviewFeature } from './analytics';
import { RESET_STATE, UPDATE_PREVIEW_ITEMS, SET_RESULTS_FOR_QUERY_ID } from './constants';
import { resultsByQueryId as resultsByQueryIdSelector } from './selectors';

export function resetState() {
  return {
    type: RESET_STATE,
  };
}

export function updatePreviewItems(previewItems, allResults) {
  // Group CI items
  const groupedCIResults = allResults.reduce((memo, item) => {
    const { groupId, databaseId } = item;
    if (UserDatabases.isCIDatabase(databaseId)) {
      // eslint-disable-next-line no-param-reassign
      memo[groupId] = memo[groupId] || [];
      memo[groupId].push(item);
    }
    return memo;
  }, {});

  // Extend preview items with related CI items,
  // exclude CI item from preview items because they will be included in multiple databases
  const updatedPreviewItems = previewItems.reduce((memo, item) => {
    const { groupId, databaseId, resultsCount, query, context } = item;
    const relatedCIItems = groupedCIResults[groupId] && groupedCIResults[groupId].filter((ciItem) => ciItem.databaseId !== databaseId);
    const fullyLoaded = get(query, 'finished') || (relatedCIItems && relatedCIItems.some((ciItem) => get(ciItem.query, 'finished')));
    const groupHasResults = resultsCount > 0 || (relatedCIItems && relatedCIItems.some((ciItem) => ciItem.resultsCount > 0));

    // Multiple databases dropdown only for Reaxys, only for substances/reactions, and only if has related ci items
    if (UserDatabases.isDefaultDatabase(databaseId) && (context === substances || context === reactions) && relatedCIItems) {
      memo.push({
        ...item,
        multipleDatabases: true,
        fullyLoaded,
        groupHasResults,
        multipleDatabasesItems: [{ ...item, databaseLabel: UserDatabases.getDbName(databaseId) }].concat(relatedCIItems),
      });
    } else if (!UserDatabases.isCIDatabase(databaseId)) {
      memo.push(item);
    }

    return memo;
  }, []);

  return {
    type: UPDATE_PREVIEW_ITEMS,
    payload: updatedPreviewItems,
  };
}

export function setResultsForQueryId({ queryId }, results) {
  return {
    type: SET_RESULTS_FOR_QUERY_ID,
    payload: {
      queryId,
      results,
    },
  };
}

export function showMoreResults(item) {
  return (dispatch, getState) => {
    trackPreviewFeature('previewresults', item);

    const handleResults = (results) => {
      dispatch(setResultsForQueryId(item, results));
    };

    const { databaseId, hitSetKey, resultName, context, semanticSearchIncluded, semanticResultName } = item;
    const results = resultsByQueryIdSelector(getState(), item);
    if (!results) {
      ResultsInterface.getResults({
        resultName,
        databaseId,
        hitSetKey,
        context,
        firstItem: 1,
        lastItem: 3,
        semanticSearchIncluded,
        semanticResultName,
        textQuery: querySelector(store.getState()),
      }).subscribe({ next: ({ data }) => handleResults(data), error: Logger.error });
    }
  };
}
